import { render, staticRenderFns } from "./DNSSECParameterFrequency.vue?vue&type=template&id=c351d1f2&"
import script from "./DNSSECParameterFrequency.vue?vue&type=script&lang=js&"
export * from "./DNSSECParameterFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports